import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { attendancePersonTargetsSearchSchema } from '@/features/operation-event/attendance-start-mock/attendancePersonTargetsSearchSchema';
export const Route = createFileRoute('/_staff/attendance-core/_layout/person-targets/')({
  validateSearch: zodValidator(attendancePersonTargetsSearchSchema)
});